import { SegmentedMessage } from 'sms-segments-calculator';

const MIN_PHONE_LENGTH = 10;
const MAX_PHONE_LENGTH = 11;
const SUPPORT_PHONE_NUMBERS = ['support'];

export const getSmsSegments = (content) => {
    const { segmentsCount } = new SegmentedMessage(content);

    return { numMessages: segmentsCount };
};

export const normalizePhoneNumber = (phoneNumber) => {
    if (phoneNumber == null) {
        return '';
    }

    let strippedPhone = phoneNumber.replace(/\D/g, '');

    // phoneNumber isn't guaranteed to be a phone number, it could be a
    // special id string (e.g. 'support')
    if (strippedPhone.length === 0) {
        return phoneNumber;
    }

    if (strippedPhone.length <= 10) {
        strippedPhone = `1${strippedPhone}`;
    }

    return strippedPhone;
};

export const normalizeNorthAmericaPhoneNumber = (phoneNumber) => {
    const sanitizedPhone = sanitizePhoneNumber(phoneNumber);

    // only append leading 1 if phone number is exactly 10 digits
    // otherwise this causes invalid 9-digit phone number to be seen as valid
    if (sanitizedPhone.length === MIN_PHONE_LENGTH) {
        return `1${sanitizedPhone}`;
    }

    return sanitizedPhone;
};

export const sanitizePhoneNumber = (phoneNumber) => {
    return phoneNumber ? phoneNumber.replace(/\D/g, '') : '';
};

export const toE164NorthAmericaPhoneFormat = (phoneNumber) => {
    // This method ONLY works with North America phone numbers and should NOT be used for non-NA numbers
    const normalizedPhone = normalizePhoneNumber(phoneNumber);

    return normalizedPhone ? `+${normalizedPhone}` : '';
};

export const isSupportNumber = (phoneNumber) => {
    return SUPPORT_PHONE_NUMBERS.includes(phoneNumber);
};

export const isValidPhoneNumber = (phoneNumber) => {
    if (isSupportNumber(phoneNumber)) {
        return true;
    }

    return normalizePhoneNumber(phoneNumber).length === MAX_PHONE_LENGTH;
};

export const isValidNorthAmericaPhoneNumber = (phoneNumber) => {
    if (phoneNumber) {
        const phone = sanitizePhoneNumber(phoneNumber);

        return (phone.length === MIN_PHONE_LENGTH || (phone.length === MAX_PHONE_LENGTH && phone.startsWith('1')));
    }

    return false;
};
